export default __webpack_public_path__ + "static/media/acct-adjustments.c5680565.png";